import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './9ab5806e272f3bac4f7891c853a16976f7915bb3d2d836c3fba9fd7ce391ad5f.cfe-internal.js';

var _excluded = ["children", "href", "target", "className"];
var Link = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '#' : _ref$href,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames(className, styles.link);
  var rel = target !== '_self' ? 'noopener noreferrer' : undefined;
  return /*#__PURE__*/React__default.createElement("a", _extends({}, rest, {
    ref: ref,
    href: href,
    target: target,
    rel: rel,
    className: classes
  }), children);
});

export { Link as default };
